import React, { useState, useContext } from 'react';
import './ha.css';
import { FaSquarePlus } from "react-icons/fa6";
import 'simplebar/dist/simplebar.min.css';
import { AuthContext } from '../../context/AuthContext';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Permit } from '../../types/types';
import HaModal from './modalHa'; 
const Ha: React.FC = () => {
    const [dashboards] = useState<string[]>([
        'https://app.powerbi.com/reportEmbed?reportId=e35c731a-0dd6-4cf1-854c-02a15032d3f6&autoAuth=true&ctid=14cb4ab4-62b8-45a2-a944-e225383ee1f9'
    ]);
    const authContext = useContext(AuthContext);
    const user = authContext?.user;
   const [isModalOpen, setIsModalOpen] = useState(false);
   
    const hasPermission = (moduleName: string, actionName: string): boolean => {
        return authContext?.user?.permits?.some((permit: Permit) =>
            permit.moduleName === moduleName && permit.actionName === actionName
        ) ?? false;
    }; 

    if (!hasPermission("ha", "read")) {
        return <div className="dashboard-container"><p>No tienes permiso para ver esta sección.</p></div>;
    }

    const handleOpenModal = () => {
        setIsModalOpen(true);
    };

    return (
        <div className="home-container no_padding">
            <div className="create-button-container">
                <span className="text_big">Módulo HA</span>
                {hasPermission("ha", "create") && (
                    <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip>Crear Proyecto</Tooltip>}
                    >
                        <FaSquarePlus className="create-button"
                            onClick={() => setIsModalOpen(true)}
                            style={{ cursor: 'pointer' }}
                        />
                    </OverlayTrigger>
                )}
            </div>           
            <div className="dashboard-container">
                {dashboards.map((dashboard, index) => (
                    <iframe
                        key={index}
                        src={dashboard}
                        width="100%"
                        height="600px"
                        frameBorder="0"
                        allowFullScreen
                        title={`Power BI Dashboard ${index + 1}`}
                    ></iframe>
                ))}
            </div>
            <HaModal isOpenHa={isModalOpen} onClose={() => setIsModalOpen(false)} />
        </div>
    );
};

export default Ha;
